module.exports = __webpack_public_path__ + "media/images/active_material/icons/create-9e1d7da3287f09910c16f94610db7290.svg";